import * as Tools from '../assets/utils/tools'
import * as Jump from '../assets/utils/jump'

export default {
    data() {
        return {

        }
    },
    methods: {
        getProperty: Tools.getProperty,
        empty: Tools.empty,
        href: Jump.href,
        back: Jump.back,
        // iconPath: filename => Tools.filePath(filename,'icon'),
        // imgPath: filename => Tools.filePath(filename,'img'),
        iconPath: filename => Tools.filePath(filename,'icon'),
        imgPath: filename => Tools.filePath(filename,'img'),
        /** 格式化背景图 */
        formatBackgroundImage(url){
            return {
                backgroundImage: "url('" + url + "')"
            }
        },
        test(a,b,c,d){
            console.log('test：', a,b,c,d);
        }
    }
}
